type StopsArgs = {
  door: string;
  material: string;
  isSDL: boolean;
  stickingStops: string;
  stickingStopsInterior: string;
  stickingStopsExterior: string;
  sdlExteriorShape: string;
  liteConfig: string;
};

export function findStopsImage(stopsArg: StopsArgs): string {
  const {
    door,
    material,
    isSDL,
    stickingStops,
    stickingStopsInterior,
    stickingStopsExterior,
    sdlExteriorShape,
    liteConfig,
  } = stopsArg;

  if (door === "Pivot" && !isSDL) {
    const liteLbl = liteConfig === '5 1/4"' ? "5.25" : "2.5";
    const materialLbl = material.includes("Clad") ? "CLAD" : "WOOD";
    const stopLbl = 
      materialLbl === "CLAD"
        ? stickingStops.toUpperCase()
        : `${stickingStopsInterior.toUpperCase()}_${stickingStopsExterior.toUpperCase()}`;

    return `Intermediate_Rail/${liteLbl}_${materialLbl}_${stopLbl}`;
  }

  if (material === "All Aluminum") {
    const liteLbl =
      liteConfig === '1 3/16"'
        ? "AA_Large_Square_SDL"
        : liteConfig === '13/16"'
          ? "AA_Medium_Square_SDL"
          : liteConfig === '11/16"'
            ? "AA_Small_Square_SDL"
            : "";
    return `SDL/${liteLbl}.jpg`;
  }

  if (material.includes("Clad") && stickingStops) {
    if (
      liteConfig === '7/8"' && sdlExteriorShape
    ) {
      return `SDL/clad${stickingStops + sdlExteriorShape}`;
    }else if(liteConfig !== '7/8"'){
      return `SDL/clad${stickingStops}Bevel`;
    }
  }

  if (
    material === "All Wood" &&
    stickingStopsInterior &&
    stickingStopsExterior
  ) {
    if (isSDL) {
      return `SDL/wood${stickingStopsInterior}${stickingStopsExterior}`;
    } else {
      return `TDL/${stickingStopsInterior.toLowerCase()}${stickingStopsExterior}`;
    }
  }

  return "";
}
